import { Box, Typography } from "@mui/material";
import "./CohortDrawerContent.css";
import useTranslationSetup from "../../utils/useTranslationSetup";

const CohortDrawerContent = ({ content }) => {
  const { t } = useTranslationSetup();
  return (
    <Box className="cohort-drawer-content">
      <Typography className="cohort-drawer-content-heading">
        {t("cohort_drawer_content_heading")}
      </Typography>
      <Typography className="cohort-drawer-content-para">{content}</Typography>
    </Box>
  );
};

export default CohortDrawerContent;
